import { render, staticRenderFns } from "./SavedResult.vue?vue&type=template&id=33c2ea7d&"
import script from "./SavedResult.vue?vue&type=script&lang=js&"
export * from "./SavedResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports